import { QueryClient } from '@tanstack/react-query';

/**
 * Client Portal reads are intentionally cached by organization and request.
 * Client data changes far less often than users move between portal pages, so
 * a five-minute freshness window keeps navigation instant while explicit
 * refresh controls still provide an immediate revalidation path.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60_000,
      gcTime: 30 * 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
    mutations: {
      retry: 0,
    },
  },
});
